import {
  Table,
  Row,
  Col,
  message,
  Modal,
  Space,
  Select,
  Pagination,
  Empty
} from "antd";

import {
  DeleteOutlined,
  ExclamationCircleOutlined,
  InfoOutlined,
  UserOutlined,
  MailOutlined,
  PhoneOutlined,
  CalendarOutlined
} from "@ant-design/icons";

import {
  useEffect,
  useState
} from "react";

import SearchProps from "../../../component/SearchProps";
import dayjs from "dayjs";
import axiosInstance from "../../../utils/axios";
import { useDevice } from "../../../hooks";


export default function UsersManage() {

  const { isMobile } =
    useDevice();

  const [user, setUser] =
    useState([]);

  const [pagination, setPagination] =
    useState({
      page: 1,
      pageSize: 10,
    });


  const fetchUser = async () => {

    await axiosInstance
      .get(
        `/user/getAll`,
        {
          params: pagination
        }
      )
      .then((res) => {

        const data =
          res?.data;

        setUser(
          data || []
        );

      })
      .catch(() =>
        message.error(
          "Không thể tải danh sách người dùng!"
        )
      );
  };


  const updateUser = async (
    value,
    id
  ) => {

    await axiosInstance
      .post(
        `/user/updateRole/${id}`,
        {
          role: value
        }
      )
      .then((res) => {

        fetchUser();

        message.success(
          String(
            res?.data?.message
          )
        );

      });
  };


  const removeUser = async (
    user_id
  ) => {

    await axiosInstance
      .delete(
        `/user/delete/${user_id}`
      )
      .then((res) => {

        fetchUser();

        message.success(
          String(
            res?.data?.message
          )
        );

      });
  };


  const confirmDelete = (
    user_id,
    displayName
  ) => {

    Modal.confirm({
      icon:
        <ExclamationCircleOutlined />,

      title:
        "Xóa người dùng",

      content:
        `Bạn có chắc chắn muốn xóa ${
          displayName || "người dùng này"
        }?`,

      okText:
        "Xóa",

      cancelText:
        "Huỷ",

      okButtonProps: {
        danger: true
      },

      onOk: () =>
        removeUser(
          user_id
        ),
    });
  };


  useEffect(() => {

    fetchUser();

  }, [pagination]);


  const optionRole = [
    {
      value: 1,
      label: "User"
    },
    {
      value: 2,
      label: "Admin"
    },
  ];


  const columns = [

    {
      title:
        <div className="base-table-cell-label">
          ID
        </div>,

      key: "user_id",
      dataIndex: "user_id",

      sorter: (a, b) =>
        a.user_id -
        b.user_id,

      width: 70,

      render: (_, record) =>
        <div>
          {record?.user_id}
        </div>,
    },


    {
      title:
        <div className="base-table-cell-label">
          Họ và Tên
        </div>,

      key: "displayName",
      dataIndex: "displayName",
      width: 280,

      ...SearchProps(
        "displayName"
      ),

      render: (_, record) =>
        <div>
          {record?.displayName}
        </div>,
    },


    {
      title:
        <div className="base-table-cell-label">
          Email
        </div>,

      key: "email",
      dataIndex: "email",
      width: 280,

      ...SearchProps(
        "email"
      ),

      render: (_, record) =>
        <div>
          {record?.email}
        </div>,
    },


    {
      title:
        <div className="base-table-cell-label">
          Số điện thoại
        </div>,

      key: "phone",
      dataIndex: "phone",
      width: 200,

      ...SearchProps(
        "phone"
      ),

      render: (_, record) =>
        <div>
          {record?.phone}
        </div>,
    },


    {
      title:
        <div className="base-table-cell-label">
          Giới tính
        </div>,

      key: "gender",
      dataIndex: "gender",
      width: 140,

      render: (_, record) =>
        <div>
          {record?.gender}
        </div>,
    },


    {
      title:
        <div className="base-table-cell-label">
          Vai trò
        </div>,

      key: "role",
      dataIndex: "role",
      width: 140,

      filters: [
        {
          text: "User",
          value: 1
        },
        {
          text: "Admin",
          value: 2
        },
      ],

      onFilter: (
        value,
        record
      ) =>
        record?.role ===
        value,

      render: (_, record) => (

        <Select
          options={
            optionRole
          }

          className="w-[100px]"

          value={
            Number(
              record?.role
            )
          }

          onChange={value =>
            updateUser(
              value,
              record?.user_id
            )
          }
        />

      ),
    },


    {
      title:
        <div className="base-table-cell-label">
          Ngày tạo
        </div>,

      key: "create_at",
      dataIndex: "create_at",
      width: 150,

      sorter: (a, b) =>
        dayjs(
          a.create_at
        ) -
        dayjs(
          b.create_at
        ),

      render: (_, record) => (

        <span>
          {record?.create_at
            ? dayjs(
                record.create_at
              ).format(
                "DD/MM/YYYY"
              )
            : "-"
          }
        </span>

      ),
    },


    {
      key: "operation",
      dataIndex: "operation",
      width: 100,

      render: (_, record) => (

        <Space>

          <InfoOutlined
            className="
              text-white
              text-xl
              rounded-full
              bg-sky-400
              p-1
              cursor-pointer
            "
          />

          <DeleteOutlined
            onClick={() =>
              confirmDelete(
                record?.user_id,
                record?.displayName
              )
            }

            className="
              text-white
              text-xl
              rounded-full
              bg-red-500
              p-1
              ml-1
              cursor-pointer
            "
          />

        </Space>

      ),
    },
  ];


  const users =
    user?.data || [];

  const total =
    Number(
      user?.total?.[0]?.total ||
      0
    );


  return (

    <div
      className="
        w-full

        bg-[#f5f7fa]

        min-h-screen

        p-3
        lg:p-0
      "
    >

      {/* PAGE TITLE - DESKTOP */}

      {!isMobile && (

        <Row
          gutter={10}
          className="mb-[8px]"
        >

          <Col flex={1}>

            <div
              className="
                text-[20px]
                font-medium
              "
            >
              Quản lý người dùng
            </div>

          </Col>

        </Row>

      )}


      {/* MOBILE */}

      {isMobile ? (

        <div className="w-full">

          <div
            className="
              flex
              items-center
              justify-between

              mb-3
              px-1
            "
          >

            <div>

              <div
                className="
                  text-[18px]
                  font-bold
                  text-gray-900
                "
              >
                Người dùng
              </div>

              <div
                className="
                  mt-1
                  text-[12px]
                  text-gray-500
                "
              >
                {total} tài khoản
              </div>

            </div>


            <div
              className="
                px-3
                py-1.5

                rounded-full

                bg-blue-50

                text-blue-600

                text-xs
                font-semibold
              "
            >
              Trang {pagination.page}
            </div>

          </div>


          {users.length > 0 ? (

            <div
              className="
                flex
                flex-col
                gap-3
              "
            >

              {users.map(
                item => (

                  <div
                    key={
                      item?.user_id
                    }

                    className="
                      bg-white

                      rounded-2xl

                      border
                      border-gray-100

                      shadow-sm

                      overflow-hidden
                    "
                  >

                    {/* USER TOP */}

                    <div
                      className="
                        p-4

                        flex
                        items-start

                        gap-3
                      "
                    >

                      <div
                        className="
                          w-11
                          h-11

                          rounded-full

                          bg-blue-50

                          text-blue-600

                          flex
                          items-center
                          justify-center

                          text-lg

                          flex-shrink-0
                        "
                      >
                        <UserOutlined />
                      </div>


                      <div
                        className="
                          flex-1
                          min-w-0
                        "
                      >

                        <div
                          className="
                            flex
                            items-start
                            justify-between

                            gap-2
                          "
                        >

                          <div
                            className="
                              flex-1
                              min-w-0
                            "
                          >

                            <div
                              className="
                                text-[15px]

                                font-bold

                                text-gray-900

                                break-words
                              "
                            >
                              {
                                item?.displayName ||
                                "Chưa có tên"
                              }
                            </div>


                            <div
                              className="
                                mt-1

                                text-[11px]

                                text-gray-400
                              "
                            >
                              ID #{item?.user_id}
                            </div>

                          </div>


                          <Select
                            options={
                              optionRole
                            }

                            value={
                              Number(
                                item?.role
                              )
                            }

                            onChange={
                              value =>
                                updateUser(
                                  value,
                                  item?.user_id
                                )
                            }

                            size="small"

                            style={{
                              width: 88
                            }}
                          />

                        </div>

                      </div>

                    </div>


                    {/* INFO */}

                    <div
                      className="
                        px-4
                        pb-4

                        space-y-2.5
                      "
                    >

                      <div
                        className="
                          flex
                          items-start

                          gap-3

                          text-[13px]
                        "
                      >

                        <MailOutlined
                          className="
                            mt-[3px]
                            text-gray-400
                          "
                        />

                        <span
                          className="
                            text-gray-700

                            break-all
                          "
                        >
                          {
                            item?.email ||
                            "Chưa có email"
                          }
                        </span>

                      </div>


                      <div
                        className="
                          flex
                          items-center

                          gap-3

                          text-[13px]
                        "
                      >

                        <PhoneOutlined
                          className="
                            text-gray-400
                          "
                        />

                        <span
                          className="
                            text-gray-700
                          "
                        >
                          {
                            item?.phone ||
                            "Chưa có số điện thoại"
                          }
                        </span>

                      </div>


                      <div
                        className="
                          flex
                          items-center

                          gap-3

                          text-[13px]
                        "
                      >

                        <CalendarOutlined
                          className="
                            text-gray-400
                          "
                        />

                        <span
                          className="
                            text-gray-700
                          "
                        >
                          Ngày tạo:{" "}

                          {
                            item?.create_at
                              ? dayjs(
                                  item.create_at
                                ).format(
                                  "DD/MM/YYYY"
                                )
                              : "-"
                          }
                        </span>

                      </div>


                      {item?.gender && (

                        <div
                          className="
                            text-[12px]
                            text-gray-500
                          "
                        >
                          Giới tính:{" "}
                          <span
                            className="
                              font-medium
                              text-gray-700
                            "
                          >
                            {item.gender}
                          </span>
                        </div>

                      )}

                    </div>


                    {/* ACTION */}

                    <div
                      className="
                        border-t
                        border-gray-100

                        px-4
                        py-3

                        flex
                        justify-end
                      "
                    >

                      <button
                        type="button"

                        onClick={() =>
                          confirmDelete(
                            item?.user_id,
                            item?.displayName
                          )
                        }

                        className="
                          h-9

                          px-4

                          rounded-lg

                          bg-red-50

                          text-red-600

                          text-[13px]

                          font-semibold

                          flex
                          items-center
                          gap-2

                          active:bg-red-100
                        "
                      >

                        <DeleteOutlined />

                        Xóa

                      </button>

                    </div>

                  </div>

                )
              )}

            </div>

          ) : (

            <div
              className="
                bg-white

                rounded-2xl

                py-16
              "
            >
              <Empty
                description="Không có người dùng"
              />
            </div>

          )}


          {/* MOBILE PAGINATION */}

          {total > 0 && (

            <div
              className="
                mt-5
                mb-8

                bg-white

                border
                border-gray-100

                rounded-2xl

                p-3

                flex
                items-center
                justify-between

                gap-2
              "
            >

              <button
                type="button"

                disabled={
                  pagination.page <= 1
                }

                onClick={() =>
                  setPagination({
                    ...pagination,
                    page:
                      pagination.page -
                      1
                  })
                }

                className="
                  h-10

                  px-4

                  rounded-xl

                  bg-gray-100

                  text-gray-700

                  font-semibold
                  text-sm

                  disabled:opacity-40
                "
              >
                Trước
              </button>


              <div
                className="
                  text-sm

                  text-gray-500

                  text-center
                "
              >
                <span
                  className="
                    font-bold
                    text-gray-900
                  "
                >
                  {pagination.page}
                </span>

                {" / "}

                {
                  Math.max(
                    1,
                    Math.ceil(
                      total /
                      pagination.pageSize
                    )
                  )
                }
              </div>


              <button
                type="button"

                disabled={
                  pagination.page >=
                  Math.ceil(
                    total /
                    pagination.pageSize
                  )
                }

                onClick={() =>
                  setPagination({
                    ...pagination,
                    page:
                      pagination.page +
                      1
                  })
                }

                className="
                  h-10

                  px-4

                  rounded-xl

                  bg-blue-600

                  text-white

                  font-semibold
                  text-sm

                  disabled:opacity-40
                "
              >
                Sau
              </button>

            </div>

          )}

        </div>

      ) : (

        /* DESKTOP GIU NGUYEN TABLE */

        <div
          className="
            w-full
            h-full

            mt-5
            pb-20

            relative
          "
        >

          <Table
            className="custom-table"

            rowKey="user_id"

            dataSource={
              users
            }

            columns={
              columns
            }

            pagination={
              false
            }

            scroll={{
              x: "max-content"
            }}
          />


          <Pagination
            className="
              flex
              justify-center

              absolute
              inset-x-0
              bottom-10
            "

            current={
              pagination.page
            }

            total={
              total
            }

            pageSize={
              pagination.pageSize
            }

            showSizeChanger

            onChange={(
              p,
              ps
            ) => {

              setPagination({
                page: p,
                pageSize: ps
              });

            }}
          />

        </div>

      )}

    </div>

  );
}
